import { ApolloLink } from "./ApolloLink.js";

/**
 * @deprecated Use `ApolloLink.from` instead. `from` will be removed in a
 * future major version.
 */
export const from = ApolloLink.from;
